module.exports = ".my-container .json-array {\n  width: 100%; }\n"